import React from 'react';
import Loading from '../views/generic/LoadingView';
import SimilarSeriesTitles, {ItemHeight} from '../views/similarSeries/SimilarSeriesTitles';
import withOtsEnabled from 'react/containers/helper/withOtsEnabled';

import { getBooksInSeries } from '../../data/BooksInSeriesSelectors';

const SimilarSeriesTitlesContainer = (props) => {
    if(props.isLoading){
       return <Loading containerHeight={ItemHeight}/>
    }
    else if(props.seriesResultData){
       return <SimilarSeriesTitles resultData={getBooksInSeries(props.seriesResultData)} marginTop={props.marginTop} marginBottom={props.marginBottom} otsEnabled={props.otsEnabled}/>
    } else {
        return null;
    }
}

export default withOtsEnabled(SimilarSeriesTitlesContainer);



// WEBPACK FOOTER //
// ./src/react/containers/SimilarSeriesTitlesContainer.jsx